export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Download',
    route: 'download',
    icon: 'DownloadIcon',
  },
  {
    title: 'Tutorials',
    route: 'tutorial',
    icon: 'BookIcon',
  },
  {
    title: 'Inspiration',
    route: 'inspiration',
    icon: 'EyeIcon',
  },
  {
    title: 'Bonuses',
    route: 'bonuses',
    icon: 'PackageIcon',
  },
  {
    title: 'Help Guides',
    route: 'help-guides',
    icon: 'HelpCircleIcon',
  },
]
